module.exports = __webpack_public_path__ + "static/img/tradizioneOmbra.0e0a26d.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/image/products/tradizioneOmbra.jpg
// module id = TDE+
// module chunks = 1